var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 128.5748031496063 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l128.5748 0l0 100.0l-128.5748 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l128.5748 0l0 100.0l-128.5748 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m24.980076 54.480896l0 0c0 -21.856747 17.718395 -39.57514 39.575146 -39.57514l0 0c10.495979 0 20.562065 4.169511 27.983849 11.59129c7.421776 7.4217777 11.591286 17.487871 11.591286 27.98385l0 0c0 21.85675 -17.718391 39.57514 -39.575134 39.57514l0 0c-21.85675 0 -39.575146 -17.718391 -39.575146 -39.57514zm18.562325 0l0 0c0 11.605057 9.407761 21.012817 21.012821 21.012817c11.605057 0 21.01281 -9.407761 21.01281 -21.012817l0 0c0 -11.605057 -9.407753 -21.012817 -21.01281 -21.012817l0 0c-11.605061 0 -21.012821 9.407761 -21.012821 21.012817z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m24.980076 54.480896l0 0c0 -21.856747 17.718395 -39.57514 39.575146 -39.57514l0 0c10.495979 0 20.562065 4.169511 27.983849 11.59129c7.421776 7.4217777 11.591286 17.487871 11.591286 27.98385l0 0c0 21.85675 -17.718391 39.57514 -39.575134 39.57514l0 0c-21.85675 0 -39.575146 -17.718391 -39.575146 -39.57514zm18.562325 0l0 0c0 11.605057 9.407761 21.012817 21.012821 21.012817c11.605057 0 21.01281 -9.407761 21.01281 -21.012817l0 0c0 -11.605057 -9.407753 -21.012817 -21.01281 -21.012817l0 0c-11.605061 0 -21.012821 9.407761 -21.012821 21.012817z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m51.820942 54.480896l0 0c0 -7.0329437 5.7013283 -12.734276 12.73428 -12.734276l0 0c3.3773346 0 6.6163483 1.3416443 9.004486 3.729782c2.3881454 2.3881416 3.729782 5.6271553 3.729782 9.004494l0 0c0 7.0329475 -5.7013245 12.734276 -12.734268 12.734276l0 0c-7.0329514 0 -12.73428 -5.7013283 -12.73428 -12.734276z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m51.820942 54.480896l0 0c0 -7.0329437 5.7013283 -12.734276 12.73428 -12.734276l0 0c3.3773346 0 6.6163483 1.3416443 9.004486 3.729782c2.3881454 2.3881416 3.729782 5.6271553 3.729782 9.004494l0 0c0 7.0329475 -5.7013245 12.734276 -12.734268 12.734276l0 0c-7.0329514 0 -12.73428 -5.7013283 -12.73428 -12.734276z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m9.460809 13.015512l0 0c0 -1.5084162 1.2228136 -2.7312298 2.7312298 -2.7312298l104.72636 0c0.72436523 0 1.4190674 0.2877531 1.9312744 0.7999582c0.5121994 0.5122051 0.7999573 1.2069044 0.7999573 1.9312716l0 10.924595c0 1.5084171 -1.2228165 2.7312298 -2.7312317 2.7312298l-104.72636 0c-1.5084162 0 -2.7312298 -1.2228127 -2.7312298 -2.7312298z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m9.460809 13.015512l0 0c0 -1.5084162 1.2228136 -2.7312298 2.7312298 -2.7312298l104.72636 0c0.72436523 0 1.4190674 0.2877531 1.9312744 0.7999582c0.5121994 0.5122051 0.7999573 1.2069044 0.7999573 1.9312716l0 10.924595c0 1.5084171 -1.2228165 2.7312298 -2.7312317 2.7312298l-104.72636 0c-1.5084162 0 -2.7312298 -1.2228127 -2.7312298 -2.7312298z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m9.460809 85.02168l0 0c0 -1.5084152 1.2228136 -2.731224 2.7312298 -2.731224l104.72636 0c0.72436523 0 1.4190674 0.28775024 1.9312744 0.7999573c0.5121994 0.51220703 0.7999573 1.2069016 0.7999573 1.9312668l0 10.924599c0 1.5084152 -1.2228165 2.7312317 -2.7312317 2.7312317l-104.72636 0c-1.5084162 0 -2.7312298 -1.2228165 -2.7312298 -2.7312317z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m9.460809 85.02168l0 0c0 -1.5084152 1.2228136 -2.731224 2.7312298 -2.731224l104.72636 0c0.72436523 0 1.4190674 0.28775024 1.9312744 0.7999573c0.5121994 0.51220703 0.7999573 1.2069016 0.7999573 1.9312668l0 10.924599c0 1.5084152 -1.2228165 2.7312317 -2.7312317 2.7312317l-104.72636 0c-1.5084162 0 -2.7312298 -1.2228165 -2.7312298 -2.7312317z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m120.81665 10.284283l0 0c3.1617355 0 5.724823 2.5630894 5.724823 5.724821l0 76.94359c0 1.5183182 -0.6031494 2.9744492 -1.6767578 4.0480576c-1.073616 1.073616 -2.529747 1.6767654 -4.048065 1.6767654l-22.89859 0c-3.1617355 0 -5.724823 -2.563095 -5.724823 -5.724823l0 -76.94359l0 0c0 -3.1617317 2.5630875 -5.724821 5.724823 -5.724821z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m120.81665 10.284283l0 0c3.1617355 0 5.724823 2.5630894 5.724823 5.724821l0 76.94359c0 1.5183182 -0.6031494 2.9744492 -1.6767578 4.0480576c-1.073616 1.073616 -2.529747 1.6767654 -4.048065 1.6767654l-22.89859 0c-3.1617355 0 -5.724823 -2.563095 -5.724823 -5.724823l0 -76.94359l0 0c0 -3.1617317 2.5630875 -5.724821 5.724823 -5.724821z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m31.094833 10.284283l0 0c3.2100296 0 5.812275 2.6022434 5.812275 5.812273l0 76.76868c0 1.5415115 -0.6123619 3.0198898 -1.7023773 4.1099014c-1.0900116 1.0900116 -2.568386 1.7023773 -4.1098976 1.7023773l-23.248398 0c-3.21003 0 -5.812274 -2.6022491 -5.812274 -5.8122787l0 -76.76868l0 0c0 -3.2100296 2.6022437 -5.812273 5.812274 -5.812273z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m31.094833 10.284283l0 0c3.2100296 0 5.812275 2.6022434 5.812275 5.812273l0 76.76868c0 1.5415115 -0.6123619 3.0198898 -1.7023773 4.1099014c-1.0900116 1.0900116 -2.568386 1.7023773 -4.1098976 1.7023773l-23.248398 0c-3.21003 0 -5.812274 -2.6022491 -5.812274 -5.8122787l0 -76.76868l0 0c0 -3.2100296 2.6022437 -5.812273 5.812274 -5.812273z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m36.90711 4.0517397l0 0c0 -1.5084167 1.2228127 -2.7312303 2.7312279 -2.7312303l49.833763 0c0.72436523 0 1.4190674 0.28775382 1.9312668 0.79995894c0.51220703 0.5122051 0.7999649 1.2069042 0.7999649 1.9312713l0 10.924594c0 1.5084171 -1.2228165 2.7312317 -2.7312317 2.7312317l-49.833763 0c-1.5084152 0 -2.7312279 -1.2228146 -2.7312279 -2.7312317z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m36.90711 4.0517397l0 0c0 -1.5084167 1.2228127 -2.7312303 2.7312279 -2.7312303l49.833763 0c0.72436523 0 1.4190674 0.28775382 1.9312668 0.79995894c0.51220703 0.5122051 0.7999649 1.2069042 0.7999649 1.9312713l0 10.924594c0 1.5084171 -1.2228165 2.7312317 -2.7312317 2.7312317l-49.833763 0c-1.5084152 0 -2.7312279 -1.2228146 -2.7312279 -2.7312317z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3843b91072985d8dd6a79165c92da118.svg";
export { ForwardRef as ReactComponent };